module.exports = __webpack_public_path__ + "images/stickers/rocketship@2x.5bd888e40e6e27bd733d.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/stickers/rocketship@2x.png
// module id = b8st
// module chunks = 0